import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { convertToLocalDateTime } from "components/helpers";
import { PanelSection } from "components/sidebar/sections/InfoPanel";
import { PanelSectionSkeleton } from "components/sidebar/sections/PanelSectionSkeleton";
import { getCampaignStatusName } from "routes/campaign/components/CampaignStatusModal";
import EntityService from "services/Entity";

// A campaign list for a record's info rail. Each row links to the campaign's
// target view for the campaign's own entity by default; a caller whose record
// links elsewhere (a case, for instance) supplies its own `buildTo`.
const campaignTargetLink = ({ campaign_id, entity_id }) =>
  `/campaigns/${campaign_id}/target/${entity_id}`;

export const CampaignList = ({ campaigns, buildTo = campaignTargetLink }) => (
  <ul className="tw:m-0 tw:flex tw:list-none tw:flex-col tw:gap-2 tw:p-0">
    {campaigns.map(
      ({
        campaign_id,
        entity_id,
        campaign_name,
        campaign_status,
        status_last_updated_at,
      }) => (
        <li key={`${campaign_id}-${entity_id}`} className="tw:flex tw:flex-col">
          <Link
            to={buildTo({ campaign_id, entity_id })}
            className="tw:text-xs tw:font-medium tw:text-sidebar-foreground! tw:hover:underline"
          >
            {campaign_name} (ID: {campaign_id})
          </Link>
          <span className="tw:text-xs tw:text-sidebar-foreground/60">
            {getCampaignStatusName(campaign_status)}
          </span>
          <span className="tw:text-xs tw:text-sidebar-foreground/60">
            Updated{" "}
            {status_last_updated_at
              ? convertToLocalDateTime(status_last_updated_at).format(
                  "YYYY-MM-DD"
                )
              : "N/A"}
          </span>
        </li>
      )
    )}
  </ul>
);

const EntityCampaignsPanel = ({ entityId }) => {
  const { data: campaigns = [], isLoading } = useQuery({
    queryKey: ["entity", entityId, "campaigns"],
    queryFn: () => EntityService.getCampaigns(entityId),
    enabled: !!entityId,
  });

  if (isLoading) {
    return <PanelSectionSkeleton />;
  }

  if (campaigns.length === 0) {
    return null;
  }

  return (
    <PanelSection title="Entity Campaigns">
      <CampaignList campaigns={campaigns} />
    </PanelSection>
  );
};

export default EntityCampaignsPanel;
